// extracted by mini-css-extract-plugin
export var footerNewsletter = "FooterNewsletterForm-module--footerNewsletter--6cb44";
export var footerNewsletter__error = "FooterNewsletterForm-module--footerNewsletter__error--59a16";
export var footerNewsletter__input = "FooterNewsletterForm-module--footerNewsletter__input--1fd06";
export var footerNewsletter__wrapper = "FooterNewsletterForm-module--footerNewsletter__wrapper--b611b";